// FinTrack — Istorija izvestaja
// Sve write operacije idu kroz SECURITY DEFINER RPC funkcije

import { state } from './state.js';
import { sb } from './supabase.js';
import { toast, svgIcon, openEditModal, showLoading, hideLoading, showConfirm } from './ui.js';
import { fNum, pDate } from './utils.js';
import XLSX from 'xlsx-js-style';

// BUILD EXCEL BASE64 (za cuvanje u bazu)
export function buildExcelBase64(type) {
  function borderAll(c) { const b = { style: 'thin', color: { rgb: c } }; return { top: b, bottom: b, left: b, right: b }; }
  function cs(v, s) { return { v, s, t: typeof v === 'number' ? 'n' : 's' }; }
  if (type === 'nedeljni') {
    if (!state.lastReport) return null;
    const { groups, kurs, from, to, totalRsd, totalUsd } = state.lastReport; const wb = XLSX.utils.book_new();
    const stH = { font: { bold: true, color: { rgb: 'FFFFFF' }, sz: 11 }, fill: { fgColor: { rgb: '0F1923' } }, alignment: { horizontal: 'center' }, border: borderAll('CCCCCC') };
    const stN = { font: { sz: 10 }, border: borderAll('E2E8F0') };
    const stU = { font: { bold: true, sz: 11, color: { rgb: '1A2738' } }, fill: { fgColor: { rgb: 'FEF08A' } }, border: borderAll('D97706') };
    const stT = { font: { bold: true, sz: 13, color: { rgb: 'FFFFFF' } }, fill: { fgColor: { rgb: '0F1923' } }, border: borderAll('1D4ED8') };
    const stNm = { ...stN, alignment: { horizontal: 'right' }, numFmt: '#,##0.000' };
    const stUm = { ...stU, alignment: { horizontal: 'right' }, numFmt: '#,##0.000' };
    const stTm = { ...stT, alignment: { horizontal: 'right' }, numFmt: '#,##0.000' };
    const det = [];
    det.push(['Vrsta tro\u0161ka', 'Vrsta (SR)', 'Komitent', 'Rok pla\u0107anja', 'Dospelo RSD', 'Dospelo USD', 'Dani ka\u0161njenja'].map(h => cs(h, stH)));
    for (const [k, g] of Object.entries(groups)) {
      for (const it of g.items) {
        const mx = it.details.length ? Math.max(...it.details.map(d => d.dk)) : 0;
        det.push([cs(k === '_unk' ? 'Nepoznato' : g.meta.name_en, stN), cs(k === '_unk' ? '' : g.meta.name_sr || '', stN), cs(it.komitent, stN), cs(it.details.map(d => d.rok).join(', '), stN), cs(it.dospelo, stNm), cs(+(it.dospelo / kurs).toFixed(3), stNm), cs(mx, { ...stN, alignment: { horizontal: 'center' } })]);
      }
      if (g.items.length) {
        det.push([cs('UKUPNO ' + (k === '_unk' ? 'Nepoznato' : g.meta.name_en), stU), cs('', stU), cs('', stU), cs('', stU), cs(g.total, stUm), cs(+(g.total / kurs).toFixed(3), stUm), cs('', stU)]);
        det.push([cs('', {}), cs('', {}), cs('', {}), cs('', {}), cs('', {}), cs('', {}), cs('', {})]);
      }
    }
    det.push([cs('', {}), cs('', {}), cs('', {}), cs('', {}), cs('', {}), cs('', {}), cs('', {})]);
    det.push([cs('TOTAL OPEX', stT), cs('', stT), cs('', stT), cs('', stT), cs(totalRsd, stTm), cs(+(totalUsd).toFixed(3), stTm), cs('', stT)]);
    const ws = XLSX.utils.aoa_to_sheet(det.map(r => r.map(c => c.v)));
    ws['!cols'] = [{ wch: 26 }, { wch: 22 }, { wch: 36 }, { wch: 28 }, { wch: 16 }, { wch: 14 }, { wch: 12 }];
    det.forEach((row, ri) => { row.forEach((cell, ci) => { const addr = XLSX.utils.encode_cell({ r: ri, c: ci }); if (!ws[addr]) ws[addr] = { v: cell.v, t: cell.t || 's' }; ws[addr].s = cell.s; }); });
    XLSX.utils.book_append_sheet(wb, ws, 'Detaljan izve\u0161taj');
    const sum = []; sum.push(['Vrsta tro\u0161ka', 'Vrsta (SR)', 'Br. komitenata', 'Ukupno RSD', 'Ukupno USD'].map(h => cs(h, stH)));
    for (const [k, g] of Object.entries(groups)) {
      if (!g.items.length) continue;
      sum.push([cs(k === '_unk' ? 'Nepoznato' : g.meta.name_en, stN), cs(k === '_unk' ? '' : g.meta.name_sr || '', stN), cs(g.items.length, { ...stN, alignment: { horizontal: 'center' } }), cs(g.total, stNm), cs(+(g.total / kurs).toFixed(3), stNm)]);
    }
    sum.push([cs('', {}), cs('', {}), cs('', {}), cs('', {}), cs('', {})]);
    sum.push([cs('TOTAL OPEX', stT), cs('', stT), cs('', stT), cs(totalRsd, stTm), cs(+(totalUsd).toFixed(3), stTm)]);
    sum.push([cs('', {}), cs('', {}), cs('', {}), cs('', {}), cs('', {})]);
    const fmt2 = d => d.toLocaleDateString('sr-RS');
    sum.push([cs('Kurs', stN), cs('1 USD = ' + kurs + ' RSD', stN), cs('', {}), cs('', {}), cs('', {})]);
    sum.push([cs('Rok: ' + fmt2(from) + ' \u2013 ' + fmt2(to), stN), cs('', {}), cs('', {}), cs('', {}), cs('', {})]);
    const ws2 = XLSX.utils.aoa_to_sheet(sum.map(r => r.map(c => c.v)));
    ws2['!cols'] = [{ wch: 26 }, { wch: 22 }, { wch: 14 }, { wch: 16 }, { wch: 14 }];
    sum.forEach((row, ri) => { row.forEach((cell, ci) => { const addr = XLSX.utils.encode_cell({ r: ri, c: ci }); if (!ws2[addr]) ws2[addr] = { v: cell.v, t: cell.t || 's' }; ws2[addr].s = cell.s; }); });
    XLSX.utils.book_append_sheet(wb, ws2, 'Sumarno');
    const d1 = from.toISOString().slice(0, 10), d2 = to.toISOString().slice(0, 10);
    const fn = 'izvestaj_' + d1 + '_' + d2 + '.xlsx';
    return { b64: XLSX.write(wb, { bookType: 'xlsx', type: 'base64', bookSST: false, cellStyles: true }), fn, from, to, totalRsd, totalUsd, kurs };
  } else {
    if (!state.kasnInvoices.length) return null;
    const wb = XLSX.utils.book_new();
    const stH = { font: { bold: true, color: { rgb: 'FFFFFF' }, sz: 11 }, fill: { fgColor: { rgb: '0F1923' } }, alignment: { horizontal: 'center' }, border: borderAll('CCCCCC') };
    const stN = { font: { sz: 10 }, border: borderAll('E2E8F0') };
    const stNm = { ...stN, alignment: { horizontal: 'right' }, numFmt: '#,##0.00' };
    const stDng = { ...stN, font: { sz: 10, bold: true, color: { rgb: 'FF0000' } }, alignment: { horizontal: 'center' } };
    const stWrn = { ...stN, font: { sz: 10, bold: true, color: { rgb: 'FF8C00' } }, alignment: { horizontal: 'center' } };
    const stOk = { ...stN, font: { sz: 10, color: { rgb: '00AA00' } }, alignment: { horizontal: 'center' } };
    const data = [];
    data.push(['#', 'Komitent', 'Kategorija', 'Datum dokumenta', 'Rok pla\u0107anja', 'Dospelo RSD', 'Dani ka\u0161njenja', 'Dokument'].map(h => cs(h, stH)));
    const totalRsd = state.kasnInvoices.reduce((s, r) => s + r.dos, 0);
    state.kasnInvoices.forEach((r, i) => {
      const dkStyle = r.dk >= 60 ? stDng : r.dk >= 30 ? stWrn : stOk;
      data.push([cs(i + 1, { ...stN, alignment: { horizontal: 'center' } }), cs(r.komitent, stN), cs(r.vrsta ? r.vrsta.name_en : 'Nekategorisan', stN), cs(r.ddok || '', stN), cs(r.rok || '', stN), cs(r.dos, stNm), cs(r.dk, dkStyle), cs((r.vd || '') + (r.bd ? ' #' + r.bd : ''), stN)]);
    });
    const ws = XLSX.utils.aoa_to_sheet(data.map(r => r.map(c => c.v)));
    ws['!cols'] = [{ wch: 6 }, { wch: 38 }, { wch: 22 }, { wch: 14 }, { wch: 14 }, { wch: 16 }, { wch: 14 }, { wch: 18 }];
    data.forEach((row, ri) => { row.forEach((cell, ci) => { const addr = XLSX.utils.encode_cell({ r: ri, c: ci }); if (!ws[addr]) ws[addr] = { v: cell.v, t: cell.t || 's' }; ws[addr].s = cell.s; }); });
    XLSX.utils.book_append_sheet(wb, ws, 'Dani ka\u0161njenja');
    const fromK = pDate(document.getElementById('dtFromK').value);
    const toK = pDate(document.getElementById('dtToK').value);
    const fn = 'dani_kasnjenja.xlsx';
    return { b64: XLSX.write(wb, { bookType: 'xlsx', type: 'base64', bookSST: false, cellStyles: true }), fn, from: fromK, to: toK, totalRsd, totalUsd: 0, kurs: 0 };
  }
}

// SAVE TO HISTORY — uses secure RPC + saves per-category breakdown
export async function saveToHistory(type) {
  const result = buildExcelBase64(type);
  if (!result) { toast('Nema izve\u0161taja za \u010duvanje', 'err'); return; }
  try {
    const { data: reportId, error } = await sb.rpc('save_report', {
      p_user_id: state.CU.id,
      p_type: type,
      p_from: result.from.toISOString().slice(0, 10),
      p_to: result.to.toISOString().slice(0, 10),
      p_rsd: result.totalRsd,
      p_usd: result.totalUsd,
      p_kurs: result.kurs,
      p_filename: result.fn,
      p_base64: result.b64
    });
    if (error) throw error;
    toast('Izve\u0161taj sa\u010duvan u istoriju');
    // Sačuvaj breakdown po vrstama troškova
    if (reportId && type === 'nedeljni' && state.lastReport) {
      const cats = [];
      for (const [key, g] of Object.entries(state.lastReport.groups)) {
        if (!g.items.length) continue;
        cats.push({
          name: key === '_unk' ? 'Uncategorized' : g.meta.name_en,
          name_sr: key === '_unk' ? 'Nekategorisani' : (g.meta.name_sr || ''),
          total: g.total,
          count: g.items.length
        });
      }
      if (cats.length) {
        try { await sb.rpc('save_report_categories', { p_report_id: reportId, p_categories: cats }); } catch (e) { console.error('SBIS:', e); }
      }
    }
  } catch (e) { toast(e.message || 'Gre\u0161ka pri \u010duvanju', 'err'); }
}

let histSortCol = 'created_at', histSortAsc = false;

// LOAD & RENDER HISTORY
export async function loadHistory() {
  showLoading();
  try {
    const { data, error } = await sb.from('report_history').select('id,user_name,report_type,period_from,period_to,total_rsd,total_usd,kurs,file_name,created_at').order('created_at', { ascending: false });
    if (error) throw error;
    state.historyData = data || [];
    renderHistory();
  } catch (e) { toast('Greška pri učitavanju istorije: ' + (e.message || ''), 'err'); }
  hideLoading();
}

export function renderHistory() {
  const tbody = document.getElementById('histBody');
  const empty = document.getElementById('histEmpty');
  if (!state.historyData.length) { tbody.textContent = ''; empty.style.display = 'block'; return; }
  empty.style.display = 'none';

  // Sortable headers
  const thead = document.querySelector('.hist-tbl thead tr');
  if (thead) {
    thead.textContent = '';
    const cols = [
      { key: null, label: '#' },
      { key: 'report_type', label: 'Tip' }, { key: 'created_at', label: 'Datum čuvanja' },
      { key: 'period_from', label: 'Period' }, { key: 'total_rsd', label: 'Ukupno RSD' },
      { key: 'total_usd', label: 'Ukupno USD' }, { key: 'kurs', label: 'Kurs' },
      { key: 'user_name', label: 'Korisnik' }, { key: null, label: '' }
    ];
    cols.forEach(c => {
      const th = document.createElement('th');
      th.textContent = c.label;
      if (c.key) {
        th.className = 'sortable' + (histSortCol === c.key ? (histSortAsc ? ' asc' : ' desc') : '');
        const si = document.createElement('span'); si.className = 'sort-icon';
        si.textContent = histSortCol === c.key ? (histSortAsc ? '\u25B2' : '\u25BC') : '\u25B4';
        th.appendChild(si);
        th.onclick = () => { if (histSortCol === c.key) histSortAsc = !histSortAsc; else { histSortCol = c.key; histSortAsc = true; } renderHistory(); };
      }
      thead.appendChild(th);
    });
  }

  // Sort data
  const sorted = [...state.historyData].sort((a, b) => {
    let va = a[histSortCol] ?? '', vb = b[histSortCol] ?? '';
    if (typeof va === 'number' && typeof vb === 'number') return histSortAsc ? va - vb : vb - va;
    va = String(va); vb = String(vb);
    return histSortAsc ? va.localeCompare(vb) : vb.localeCompare(va);
  });

  const fmtD = s => { const d = new Date(s); return d.toLocaleDateString('sr-RS'); };
  const fmtDT = s => { const d = new Date(s); return d.toLocaleDateString('sr-RS') + ' ' + d.toLocaleTimeString('sr-RS', { hour: '2-digit', minute: '2-digit' }); };
  tbody.textContent = '';
  sorted.forEach((h, i) => {
    const tr = document.createElement('tr'); tr.style.cursor = 'pointer';
    tr.title = 'Klikni za detaljan prikaz';
    const td1 = document.createElement('td'); td1.style.color = 'var(--tx3)'; td1.textContent = i + 1;
    const td2 = document.createElement('td');
    const badge = document.createElement('span'); badge.className = 'hist-type ' + (h.report_type === 'nedeljni' ? 'ned' : 'kas'); badge.textContent = h.report_type === 'nedeljni' ? 'Nedeljni' : 'Ka\u0161njenja'; td2.appendChild(badge);
    const td3 = document.createElement('td'); td3.textContent = fmtDT(h.created_at);
    const td4 = document.createElement('td'); td4.className = 'hmn'; td4.textContent = fmtD(h.period_from) + ' \u2014 ' + fmtD(h.period_to);
    const td5 = document.createElement('td'); td5.className = 'hmn'; td5.style.color = 'var(--dng)'; td5.textContent = fNum(h.total_rsd);
    const td6 = document.createElement('td'); td6.className = 'hmn'; td6.textContent = fNum(h.total_usd);
    const td7 = document.createElement('td'); td7.className = 'hmn'; td7.textContent = fNum(h.kurs);
    const td8 = document.createElement('td'); td8.textContent = h.user_name;
    const td9 = document.createElement('td'); td9.style.cssText = 'white-space:nowrap';
    const btnDl = document.createElement('button'); btnDl.className = 'bsm'; btnDl.appendChild(svgIcon('download', 14)); btnDl.appendChild(document.createTextNode(' Excel')); btnDl.onclick = e => { e.stopPropagation(); downloadHistory(h.id); };
    const btnDel = document.createElement('button'); btnDel.className = 'bsm dng'; btnDel.appendChild(svgIcon('trash', 14)); btnDel.appendChild(document.createTextNode(' Obriši')); btnDel.onclick = e => { e.stopPropagation(); deleteHistory(h.id, h.report_type, h.created_at); };
    td9.appendChild(btnDl); td9.appendChild(document.createTextNode(' ')); td9.appendChild(btnDel);
    tr.appendChild(td1); tr.appendChild(td2); tr.appendChild(td3); tr.appendChild(td4); tr.appendChild(td5); tr.appendChild(td6); tr.appendChild(td7); tr.appendChild(td8); tr.appendChild(td9);
    tbody.appendChild(tr);

    // Detail row (hidden, loads on click)
    const detailTr = document.createElement('tr'); detailTr.style.display = 'none';
    const detailTd = document.createElement('td'); detailTd.colSpan = 9; detailTd.style.cssText = 'padding:0;background:var(--base)';
    detailTr.appendChild(detailTd);
    tbody.appendChild(detailTr);

    tr.onclick = () => {
      const open = detailTr.style.display !== 'none';
      detailTr.style.display = open ? 'none' : 'table-row';
      if (!open && !detailTd.dataset.loaded) {
        detailTd.dataset.loaded = '1';
        loadReportDetail(detailTd, h.id, h.kurs);
      }
    };
  });
}

// EDIT HISTORY AMOUNTS — update total_rsd/total_usd directly
function editHistoryAmounts(h) {
  openEditModal('Izmeni iznos izveštaja', [
    { label: 'Ukupno RSD', value: h.total_rsd || '0', key: 'total_rsd', type: 'number', step: '0.01' }
  ], async (vals) => {
    const rsd = parseFloat(vals.total_rsd) || 0;
    const kurs = h.kurs || 1;
    const usd = kurs > 0 ? rsd / kurs : 0;
    try {
      const { error } = await sb.from('report_history').update({ total_rsd: rsd, total_usd: usd }).eq('id', h.id).eq('user_id', state.CU.id);
      if (error) throw error;
      h.total_rsd = rsd; h.total_usd = usd;
      renderHistory();
      toast('Iznos ažuriran');
    } catch (e) { toast('Greška: ' + (e.message || e), 'err'); }
  });
}

// DOWNLOAD FROM HISTORY — uses secure RPC
export async function downloadHistory(id) {
  try {
    const { data, error } = await sb.rpc('get_report_file', { p_user_id: state.CU.id, p_report_id: id });
    if (error) throw error;
    if (!data || !data.length) throw { message: 'Izveštaj nije pronađen' };
    const file = data[0];
    const bin = atob(file.excel_base64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
    const blob = new Blob([arr], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a'); a.href = url; a.download = file.file_name; a.click();
    URL.revokeObjectURL(url);
    toast('Preuzimanje pokrenuto');
  } catch (e) { toast(e.message || 'Gre\u0161ka pri preuzimanju', 'err'); }
}

// DELETE FROM HISTORY — uses secure RPC with descriptive confirmation
export async function deleteHistory(id, type, createdAt) {
  const fmtDT = s => { const d = new Date(s); return d.toLocaleDateString('sr-RS') + ' ' + d.toLocaleTimeString('sr-RS', { hour: '2-digit', minute: '2-digit' }); };
  const typeName = type === 'nedeljni' ? 'nedeljni izveštaj' : 'izveštaj kašnjenja';
  showConfirm('Obrisati ' + typeName + ' od ' + fmtDT(createdAt) + '? Ova akcija je nepovratna.', async () => { try {
    const { error } = await sb.rpc('delete_report', { p_user_id: state.CU.id, p_report_id: id });
    if (error) throw error;
    toast('Obrisano');
    loadHistory();
  } catch (e) { toast(e.message || 'Gre\u0161ka pri brisanju', 'err'); } });
}

// ============================================================
// DETAIL VIEW — loads details_json for a saved report
// ============================================================
async function loadReportDetail(container, reportId, kurs) {
  container.textContent = '';
  const loader = document.createElement('div'); loader.style.cssText = 'padding:20px;color:var(--tx3);font-size:14px';
  loader.textContent = 'Učitavanje detalja...'; container.appendChild(loader);
  try {
    const { data, error } = await sb.rpc('get_report_detail', { p_user_id: state.CU.id, p_report_id: reportId });
    if (error) throw error;
    container.textContent = '';
    if (!data || !data.length || !data[0].details_json) {
      const p = document.createElement('div'); p.style.cssText = 'padding:20px;color:var(--tx3);font-size:14px';
      p.textContent = 'Detaljni podaci nisu dostupni za ovaj izveštaj.';
      container.appendChild(p); return;
    }
    const rep = data[0];
    const k = parseFloat(rep.kurs) || parseFloat(kurs) || 1;
    const groups = rep.details_json;

    const wrap = document.createElement('div'); wrap.style.cssText = 'padding:16px 20px';

    // Main table with proper columns
    const tbl = document.createElement('table'); tbl.style.cssText = 'width:100%;border-collapse:collapse';
    const thead = document.createElement('thead');
    const htr = document.createElement('tr'); htr.style.cssText = 'border-bottom:2px solid var(--border);position:sticky;top:0;background:var(--raised);z-index:1';
    [{ h: 'Komitent', a: 'left', w: '' }, { h: 'Duguje RSD', a: 'right', w: '18%' }, { h: 'Duguje USD', a: 'right', w: '16%' }, { h: 'Dani', a: 'right', w: '8%' }].forEach(c => {
      const th = document.createElement('th'); th.textContent = c.h;
      th.style.cssText = 'padding:12px 14px;font-size:16px;color:var(--tx3);text-transform:uppercase;letter-spacing:.5px;text-align:' + c.a;
      if (c.w) th.style.width = c.w;
      htr.appendChild(th);
    });
    thead.appendChild(htr); tbl.appendChild(thead);
    const tbody = document.createElement('tbody');

    groups.sort((a, b) => b.total - a.total).forEach(g => {
      // Group header row
      const gtr = document.createElement('tr'); gtr.style.cssText = 'background:var(--surface);border-bottom:2px solid var(--acc)';
      const gtd1 = document.createElement('td'); gtd1.style.cssText = 'padding:14px;font-weight:700;font-size:16px;color:var(--acc)';
      gtd1.textContent = (g.icon ? g.icon + ' ' : '') + g.group + (g.group_sr ? ' \u2014 ' + g.group_sr : '');
      const gCnt = document.createElement('span'); gCnt.style.cssText = 'font-size:16px;color:var(--tx3);margin-left:10px;font-weight:400'; gCnt.textContent = (g.items || []).length + ' kom.';
      gtd1.appendChild(gCnt);
      const gtd2 = document.createElement('td'); gtd2.style.cssText = 'padding:14px;text-align:right;font-family:var(--mn);font-size:16px;font-weight:700;color:var(--dng)'; gtd2.textContent = fNum(g.total);
      const gUsdVal = g.total / k;
      const gtd3 = document.createElement('td'); gtd3.style.cssText = 'padding:14px;text-align:right;font-family:var(--mn);font-size:16px;font-weight:600;color:var(--acc)'; gtd3.textContent = g.total > 0 && Math.abs(gUsdVal) < 0.01 ? '< 0,01' : fNum(gUsdVal);
      const gtd4 = document.createElement('td'); gtd4.style.padding = '14px';
      gtr.appendChild(gtd1); gtr.appendChild(gtd2); gtr.appendChild(gtd3); gtr.appendChild(gtd4);
      tbody.appendChild(gtr);

      // Item rows
      (g.items || []).sort((a, b) => b.dospelo - a.dospelo).forEach(it => {
        const tr = document.createElement('tr'); tr.style.borderBottom = '1px solid var(--border-lt)';
        const td1 = document.createElement('td'); td1.style.cssText = 'padding:10px 14px 10px 28px;color:var(--tx);font-size:16px'; td1.textContent = it.komitent;
        const td2 = document.createElement('td'); td2.style.cssText = 'padding:10px 14px;text-align:right;font-family:var(--mn);font-size:16px;color:var(--dng)'; td2.textContent = fNum(it.dospelo);
        const itUsd = it.dospelo / k;
        const td3 = document.createElement('td'); td3.style.cssText = 'padding:10px 14px;text-align:right;font-family:var(--mn);font-size:16px;color:var(--tx3)'; td3.textContent = it.dospelo > 0 && Math.abs(itUsd) < 0.01 ? '< 0,01' : fNum(itUsd);
        const maxDk = it.details && it.details.length ? Math.max(...it.details.map(d => d.dk || 0)) : 0;
        const td4 = document.createElement('td'); td4.style.cssText = 'padding:10px 14px;text-align:right;font-size:14px;font-weight:600';
        if (maxDk > 0) { td4.style.color = 'var(--dng)'; td4.textContent = maxDk + 'd'; }
        tr.appendChild(td1); tr.appendChild(td2); tr.appendChild(td3); tr.appendChild(td4);
        tbody.appendChild(tr);
      });
    });

    // Totals row — gold accent
    const ttr = document.createElement('tr'); ttr.style.cssText = 'background:rgba(201,168,76,.15);border-top:3px solid var(--acc)';
    const tt1 = document.createElement('td'); tt1.style.cssText = 'padding:16px 14px;font-size:16px;font-weight:700;color:var(--acc)'; tt1.textContent = 'UKUPNO';
    const tt2 = document.createElement('td'); tt2.style.cssText = 'padding:16px 14px;text-align:right;font-family:var(--mn);font-size:16px;font-weight:700;color:var(--dng)'; tt2.textContent = fNum(parseFloat(rep.total_rsd));
    const tt3 = document.createElement('td'); tt3.style.cssText = 'padding:16px 14px;text-align:right;font-family:var(--mn);font-size:16px;font-weight:700;color:var(--acc)'; tt3.textContent = fNum(parseFloat(rep.total_usd));
    const tt4 = document.createElement('td'); tt4.style.padding = '16px 14px';
    ttr.appendChild(tt1); ttr.appendChild(tt2); ttr.appendChild(tt3); ttr.appendChild(tt4);
    tbody.appendChild(ttr);

    tbl.appendChild(tbody); wrap.appendChild(tbl);
    container.appendChild(wrap);
  } catch (e) {
    container.textContent = '';
    const p = document.createElement('div'); p.style.cssText = 'padding:20px;color:var(--dng);font-size:14px';
    p.textContent = 'Greška: ' + (e.message || e); container.appendChild(p);
  }
}

// ============================================================
// TAB SWITCHING
// ============================================================
export function showHistTab(tab) {
  const boxes = { reports: 'histReportsBox', knjizenja: 'histKnjizenjaBox', kasnjenja: 'histKasnjenjaBox', mesecni: 'histMesecniBox', activity: 'histActivityBox' };
  const btns = { reports: 'btnHistReports', knjizenja: 'btnHistKnjizenja', kasnjenja: 'btnHistKasnjenja', mesecni: 'btnHistMesecni', activity: 'btnHistActivity' };
  Object.values(boxes).forEach(id => { const el = document.getElementById(id); if (el) el.style.display = 'none'; });
  Object.values(btns).forEach(id => { const el = document.getElementById(id); if (el) el.classList.remove('active'); });
  const box = document.getElementById(boxes[tab]); if (box) box.style.display = '';
  const btn = document.getElementById(btns[tab]); if (btn) btn.classList.add('active');
  if (tab === 'knjizenja') loadHistKnjizenja();
  if (tab === 'kasnjenja') loadHistKasnjenja();
  if (tab === 'mesecni') loadHistMesecni();
  if (tab === 'activity') loadHistActivity();
}

// ============================================================
// ISTORIJA KNJIŽENJA (sačuvani izvodi)
// ============================================================
async function loadHistKnjizenja() {
  const content = document.getElementById('histKjContent');
  const empty = document.getElementById('histKjEmpty');
  if (!content) return;
  content.textContent = '';
  showLoading();
  try {
    const { data, error } = await sb.rpc('get_saved_izvodi', { p_user_id: state.CU.id });
    if (error) throw error;
    if (!data || !data.length) { if (empty) empty.style.display = 'block'; hideLoading(); return; }
    if (empty) empty.style.display = 'none';

    const card = document.createElement('div'); card.className = 'card'; card.style.cssText = 'padding:0;overflow-x:auto';
    const tbl = document.createElement('table'); tbl.className = 'hist-tbl';
    const thead = document.createElement('thead');
    const htr = document.createElement('tr');
    ['#', 'Broj izvoda', 'Period', 'Datum', 'Stavki', 'Duguje (RSD)', 'Potražuje (RSD)', ''].forEach(h => {
      const th = document.createElement('th'); th.textContent = h; htr.appendChild(th);
    });
    thead.appendChild(htr); tbl.appendChild(thead);

    const fmtD = s => s ? new Date(s).toLocaleDateString('sr-RS') : '\u2014';
    // Check for gaps between periods
    const withPeriods = data.filter(iz => iz.period_from && iz.period_to).sort((a, b) => new Date(a.period_from) - new Date(b.period_from));
    const gaps = [];
    for (let i = 1; i < withPeriods.length; i++) {
      const prevEnd = new Date(withPeriods[i-1].period_to);
      const curStart = new Date(withPeriods[i].period_from);
      const gapDays = Math.round((curStart - prevEnd) / 86400000) - 1;
      if (gapDays > 0) {
        const nextDay = new Date(prevEnd); nextDay.setDate(nextDay.getDate() + 1);
        const dayBefore = new Date(curStart); dayBefore.setDate(dayBefore.getDate() - 1);
        gaps.push(fmtD(nextDay) + ' \u2014 ' + fmtD(dayBefore) + ' (' + gapDays + ' dana)');
      }
    }
    if (gaps.length) {
      const warn = document.createElement('div'); warn.style.cssText = 'padding:10px 14px;background:var(--dng-bg);border:1px solid rgba(255,92,106,.15);border-radius:var(--rx);font-size:12px;color:var(--warn);margin-bottom:12px';
      warn.textContent = '\u26A0 Gap u periodima: ' + gaps.join(', ');
      content.appendChild(warn);
    }

    const tbody = document.createElement('tbody');
    data.forEach((iz, i) => {
      const tr = document.createElement('tr'); tr.style.cursor = 'pointer'; tr.title = 'Klikni za detalje';
      const td0 = document.createElement('td'); td0.style.color = 'var(--tx3)'; td0.textContent = i + 1;
      const td1 = document.createElement('td'); td1.style.cssText = 'font-weight:600;color:var(--acc)'; td1.textContent = iz.izvod_number;
      const tdP = document.createElement('td'); tdP.style.cssText = 'font-size:16px;color:var(--tx)';
      tdP.textContent = iz.period_from ? fmtD(iz.period_from) + ' \u2014 ' + fmtD(iz.period_to) : '\u2014';
      const td2 = document.createElement('td'); td2.style.cssText = 'font-size:14px;color:var(--tx3)';
      td2.textContent = new Date(iz.saved_at).toLocaleString('sr-RS', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
      const td3 = document.createElement('td'); td3.textContent = iz.entry_count;
      const td4 = document.createElement('td'); td4.className = 'hmn'; td4.style.color = 'var(--dng)'; td4.textContent = fNum(iz.total_debit);
      const td5 = document.createElement('td'); td5.className = 'hmn'; td5.style.color = 'var(--suc)'; td5.textContent = fNum(iz.total_credit);
      const td7 = document.createElement('td'); td7.style.cssText = 'white-space:nowrap;display:flex;gap:6px';
      const btnExp = document.createElement('button'); btnExp.className = 'bsm'; btnExp.appendChild(svgIcon('download', 14)); btnExp.appendChild(document.createTextNode(' Export Excel (QuickBooks)'));
      btnExp.onclick = e => { e.stopPropagation(); exportIzvodXlsx(iz.batch_id, iz.izvod_number, iz.period_from, iz.period_to); };
      const btnDel = document.createElement('button'); btnDel.className = 'bsm dng'; btnDel.appendChild(svgIcon('trash', 14)); btnDel.appendChild(document.createTextNode(' Obriši'));
      btnDel.onclick = e => { e.stopPropagation(); deleteIzvod(iz.batch_id, iz.izvod_number); };
      td7.appendChild(btnExp); td7.appendChild(btnDel);
      tr.appendChild(td0); tr.appendChild(td1); tr.appendChild(tdP); tr.appendChild(td2); tr.appendChild(td3); tr.appendChild(td4); tr.appendChild(td5); tr.appendChild(td7);
      tbody.appendChild(tr);

      // Detail row
      const detailTr = document.createElement('tr'); detailTr.style.display = 'none';
      const detailTd = document.createElement('td'); detailTd.colSpan = 9; detailTd.style.cssText = 'padding:0;background:var(--base)';
      detailTr.appendChild(detailTd); tbody.appendChild(detailTr);
      tr.onclick = () => {
        const open = detailTr.style.display !== 'none';
        detailTr.style.display = open ? 'none' : 'table-row';
        if (!open && !detailTd.dataset.loaded) { detailTd.dataset.loaded = '1'; loadIzvodDetail(detailTd, iz.batch_id); }
      };
    });
    tbl.appendChild(tbody); card.appendChild(tbl); content.appendChild(card);
  } catch (e) { content.textContent = 'Greška: ' + (e.message || e); }
  hideLoading();
}

// ============================================================
// KNJIŽENJA DETAIL + DELETE
// ============================================================
async function loadIzvodDetail(container, batchId) {
  container.textContent = '';
  const loader = document.createElement('div'); loader.style.cssText = 'padding:16px;color:var(--tx3);font-size:13px';
  loader.textContent = 'Učitavanje stavki...'; container.appendChild(loader);
  try {
    const { data, error } = await sb.rpc('get_izvod_entries', { p_batch_id: batchId });
    if (error) throw error;
    container.textContent = '';
    if (!data || !data.length) {
      const p = document.createElement('div'); p.style.cssText = 'padding:20px;color:var(--tx3);font-size:14px';
      p.textContent = 'Nema stavki.'; container.appendChild(p); return;
    }
    const wrap = document.createElement('div'); wrap.style.cssText = 'padding:16px 20px';

    const byFile = {};
    const analytics = [];
    data.forEach(e => { if (e.detail_level === 'ANALYTIC') { analytics.push(e); return; } const key = e.source_file || '(bez fajla)'; if (!byFile[key]) byFile[key] = []; byFile[key].push(e); });

    // One big table with column headers
    const tbl = document.createElement('table'); tbl.style.cssText = 'width:100%;border-collapse:collapse';
    const thead = document.createElement('thead');
    const htr = document.createElement('tr'); htr.style.cssText = 'border-bottom:2px solid var(--border);position:sticky;top:0;background:var(--raised);z-index:1';
    [{ h: 'Konto', a: 'left', w: '10%' }, { h: 'Naziv', a: 'left', w: '' }, { h: 'Duguje', a: 'right', w: '20%' }, { h: 'Potražuje', a: 'right', w: '20%' }].forEach(c => {
      const th = document.createElement('th'); th.textContent = c.h;
      th.style.cssText = 'padding:12px 14px;font-size:16px;color:var(--tx3);text-transform:uppercase;letter-spacing:.5px;text-align:' + c.a;
      if (c.w) th.style.width = c.w;
      htr.appendChild(th);
    });
    thead.appendChild(htr); tbl.appendChild(thead);
    const tbody = document.createElement('tbody');

    let totalD = 0, totalC = 0;
    const ANALYTIC_KONTA = ['150','153','204','205','435','436'];

    Object.entries(byFile).forEach(([file, entries]) => {
      // File header row
      const ftr = document.createElement('tr'); ftr.style.cssText = 'background:var(--surface);border-bottom:1px solid var(--border)';
      const ftd = document.createElement('td'); ftd.colSpan = 4; ftd.style.cssText = 'padding:12px 14px;font-size:16px;font-weight:600;color:var(--tx3)';
      ftd.textContent = '\uD83D\uDCC4 ' + file.replace(/FINANSIJSKO KNJIZENJE /g, '').replace(/_Privredno[^.]*/g, '');
      ftr.appendChild(ftd); tbody.appendChild(ftr);

      let fileD = 0, fileC = 0;
      entries.forEach(e => {
        const d = parseFloat(e.debit || 0), c = parseFloat(e.credit || 0);
        totalD += d; totalC += c; fileD += d; fileC += c;

        const tr = document.createElement('tr'); tr.style.borderBottom = '1px solid var(--border-lt)';
        const td1 = document.createElement('td'); td1.style.cssText = 'padding:10px 14px;font-family:var(--mn);font-weight:700;color:var(--acc);font-size:16px'; td1.textContent = e.rs_code || '';
        const td2 = document.createElement('td'); td2.style.cssText = 'padding:10px 14px;color:var(--tx);font-size:16px'; td2.textContent = e.en_name || '';
        const td3 = document.createElement('td'); td3.style.cssText = 'padding:10px 14px;text-align:right;font-family:var(--mn);font-size:16px';
        if (d > 0) { td3.textContent = fNum(d); td3.style.color = 'var(--dng)'; }
        const td4 = document.createElement('td'); td4.style.cssText = 'padding:10px 14px;text-align:right;font-family:var(--mn);font-size:16px';
        if (c > 0) { td4.textContent = fNum(c); td4.style.color = 'var(--suc)'; }
        tr.appendChild(td1); tr.appendChild(td2); tr.appendChild(td3); tr.appendChild(td4);
        tbody.appendChild(tr);

        if (e.detail_level === 'PARENT' && ANALYTIC_KONTA.includes(e.rs_code)) {
          analytics.filter(a => a.parent_code === e.rs_code && a.source_file === e.source_file).forEach(a => {
            const ad = parseFloat(a.debit || 0), ac = parseFloat(a.credit || 0);
            const atr = document.createElement('tr'); atr.style.cssText = 'border-bottom:1px solid var(--border-lt);background:rgba(201,168,76,.04)';
            const atd1 = document.createElement('td'); atd1.style.cssText = 'padding:8px 14px 8px 34px;font-family:var(--mn);font-size:16px;color:var(--tx3)'; atd1.textContent = a.analytic_code || '';
            const atd2 = document.createElement('td'); atd2.style.cssText = 'padding:8px 14px;font-size:16px;color:var(--acc)'; atd2.textContent = '\u2514 ' + (a.analytic_name || '');
            const atd3 = document.createElement('td'); atd3.style.cssText = 'padding:8px 14px;text-align:right;font-family:var(--mn);font-size:16px';
            if (ad > 0) { atd3.textContent = fNum(ad); atd3.style.color = 'var(--dng)'; }
            const atd4 = document.createElement('td'); atd4.style.cssText = 'padding:8px 14px;text-align:right;font-family:var(--mn);font-size:16px';
            if (ac > 0) { atd4.textContent = fNum(ac); atd4.style.color = 'var(--suc)'; }
            atr.appendChild(atd1); atr.appendChild(atd2); atr.appendChild(atd3); atr.appendChild(atd4);
            tbody.appendChild(atr);
          });
        }
      });
      // File subtotal — blue tint
      const str = document.createElement('tr'); str.style.cssText = 'background:rgba(60,130,200,.12);border-top:2px solid rgba(60,130,200,.3)';
      const st1 = document.createElement('td'); st1.colSpan = 2; st1.style.cssText = 'padding:12px 14px;font-size:14px;font-weight:700;color:var(--tx)'; st1.textContent = 'Ukupno';
      const st3 = document.createElement('td'); st3.style.cssText = 'padding:12px 14px;text-align:right;font-family:var(--mn);font-size:16px;font-weight:700;color:var(--dng)'; st3.textContent = fNum(fileD);
      const st4 = document.createElement('td'); st4.style.cssText = 'padding:12px 14px;text-align:right;font-family:var(--mn);font-size:16px;font-weight:700;color:var(--suc)'; st4.textContent = fNum(fileC);
      str.appendChild(st1); str.appendChild(st3); str.appendChild(st4); tbody.appendChild(str);
    });

    // Grand total — gold/amber accent
    const gtr = document.createElement('tr'); gtr.style.cssText = 'background:rgba(201,168,76,.15);border-top:3px solid var(--acc)';
    const gt1 = document.createElement('td'); gt1.colSpan = 2; gt1.style.cssText = 'padding:16px 14px;font-size:16px;font-weight:700;color:var(--acc)'; gt1.textContent = 'UKUPNO';
    const gt3 = document.createElement('td'); gt3.style.cssText = 'padding:16px 14px;text-align:right;font-family:var(--mn);font-size:16px;font-weight:700;color:var(--dng)'; gt3.textContent = fNum(totalD);
    const gt4 = document.createElement('td'); gt4.style.cssText = 'padding:16px 14px;text-align:right;font-family:var(--mn);font-size:16px;font-weight:700;color:var(--suc)'; gt4.textContent = fNum(totalC);
    gtr.appendChild(gt1); gtr.appendChild(gt3); gtr.appendChild(gt4); tbody.appendChild(gtr);
    // Razlika row — gold bg
    const diff = Math.abs(totalD - totalC);
    const dtr = document.createElement('tr'); dtr.style.cssText = 'background:rgba(201,168,76,.08)';
    const dt1 = document.createElement('td'); dt1.colSpan = 2; dt1.style.cssText = 'padding:12px 14px;font-size:14px;font-weight:600;color:var(--acc)'; dt1.textContent = 'Saldo';
    const dt3 = document.createElement('td'); dt3.colSpan = 2; dt3.style.cssText = 'padding:12px 14px;text-align:right;font-family:var(--mn);font-size:16px;font-weight:700;color:' + (diff < 1 ? 'var(--suc)' : 'var(--warn)'); dt3.textContent = fNum(diff);
    dtr.appendChild(dt1); dtr.appendChild(dt3); tbody.appendChild(dtr);

    tbl.appendChild(tbody); wrap.appendChild(tbl);
    container.appendChild(wrap);
  } catch (e) {
    container.textContent = '';
    const p = document.createElement('div'); p.style.cssText = 'padding:16px;color:var(--dng);font-size:13px';
    p.textContent = 'Greška: ' + (e.message || e); container.appendChild(p);
  }
}

async function exportIzvodXlsx(batchId, izvodName, periodFrom, periodTo) {
  if (!state.CU) return;
  showLoading();
  try {
    // Učitaj sve entries za ovaj izvod
    let allData = [], offset = 0;
    while (true) {
      const { data, error } = await sb.from('knjizenja_entries')
        .select('rs_code,rs_name,en_code,en_name,debit,credit,detail_level,analytic_code,analytic_name,booking_date,source_file,mapping_status')
        .eq('user_id', state.CU.id).eq('is_final', true).eq('batch_id', batchId)
        .range(offset, offset + 999);
      if (error) throw error;
      if (!data || !data.length) break;
      allData.push(...data);
      if (data.length < 1000) break;
      offset += 1000;
    }
    if (!allData.length) { toast('Nema podataka za export', 'err'); hideLoading(); return; }

    // QuickBooks Journal Entry format
    const wb = XLSX.utils.book_new();
    function borderAll(c) { const b = { style: 'thin', color: { rgb: c } }; return { top: b, bottom: b, left: b, right: b }; }
    function cs(v, s) { return { v, s, t: typeof v === 'number' ? 'n' : 's' }; }
    const stH = { font: { bold: true, color: { rgb: 'FFFFFF' }, sz: 11 }, fill: { fgColor: { rgb: '0F1923' } }, alignment: { horizontal: 'center' }, border: borderAll('CCCCCC') };
    const stN = { font: { sz: 10 }, border: borderAll('E2E8F0') };
    const stNm = { ...stN, alignment: { horizontal: 'right' }, numFmt: '#,##0.00' };

    const headers = ['*JournalNo', '*JournalDate', 'AccountCode', '*AccountName', 'Debits', 'Credits', 'Description', 'Name'];
    const data = [];
    data.push(headers.map(h => cs(h, stH)));

    const exportEntries = allData.filter(e => e.detail_level !== 'PARENT' && e.detail_level !== 'ERROR');
    const byFile = {};
    exportEntries.forEach(e => { if (!byFile[e.source_file]) byFile[e.source_file] = []; byFile[e.source_file].push(e); });

    let jnr = 1;
    for (const [file, entries] of Object.entries(byFile)) {
      const shortName = file.replace(/FINANSIJSKO KNJIZENJE /g, '').replace(/_Privredno.*/, '');
      entries.forEach(e => {
        const d = parseFloat(e.debit) || 0, c = parseFloat(e.credit) || 0;
        const acctName = e.en_name || e.rs_name || '';
        // Za konta 204,205,430 (kupci) dodaj (C) suffix na ime za QBO Customer matching
        const isCustomerKonto = ['204','205','430'].includes(e.rs_code);
        let vendorName = e.detail_level === 'ANALYTIC' ? (e.analytic_name || '') : '';
        if (vendorName && isCustomerKonto) vendorName += ' (C)';
        const parts = (e.booking_date || '').split('.');
        const qbDate = parts.length === 3 ? parts[1] + '/' + parts[0] + '/' + parts[2] : e.booking_date;
        data.push([
          cs(jnr, stN), cs(qbDate, stN), cs(e.en_code || '', stN), cs(acctName, stN),
          cs(d || '', stNm), cs(c || '', stNm), cs(shortName, stN), cs(vendorName, stN)
        ]);
      });
      jnr++;
    }

    const ws = XLSX.utils.aoa_to_sheet(data.map(r => r.map(c => c.v)));
    ws['!cols'] = [{ wch: 12 }, { wch: 12 }, { wch: 12 }, { wch: 30 }, { wch: 14 }, { wch: 14 }, { wch: 35 }, { wch: 25 }];
    data.forEach((row, ri) => { row.forEach((cell, ci) => { const addr = XLSX.utils.encode_cell({ r: ri, c: ci }); if (ws[addr]) ws[addr].s = cell.s; }); });

    XLSX.utils.book_append_sheet(wb, ws, 'Journal Entries');
    XLSX.writeFile(wb, 'QuickBooks_' + izvodName + '.xlsx', { bookSST: false, cellStyles: true });
    toast('Excel eksportovan: ' + izvodName);
  } catch (e) { toast('Greška: ' + (e.message || e), 'err'); }
  hideLoading();
}

function deleteIzvod(batchId, izvodName) {
  showConfirm('Obrisati knjiženje "' + izvodName + '"? Ova akcija je nepovratna.', async () => {
    try {
      const { error } = await sb.rpc('delete_izvod', { p_user_id: state.CU.id, p_batch_id: batchId });
      if (error) throw error;
      toast('Knjiženje obrisano');
      loadHistKnjizenja();
    } catch (e) { toast('Greška: ' + (e.message || e), 'err'); }
  });
}

// ============================================================
// ISTORIJA DANI KAŠNJENJA
// ============================================================
async function loadHistKasnjenja() {
  const content = document.getElementById('histKasnContent');
  const empty = document.getElementById('histKasnEmpty');
  if (!content) return;
  content.textContent = '';
  showLoading();
  try {
    const { data, error } = await sb.rpc('get_saved_reports', { p_user_id: state.CU.id, p_limit: 5 });
    if (error) throw error;
    const kasnReports = (data || []).filter(r => r.report_type === 'kasnjenja');
    if (!kasnReports.length) { if (empty) empty.style.display = 'block'; hideLoading(); return; }
    if (empty) empty.style.display = 'none';

    const rep = kasnReports[0]; // samo jedan (upsert)
    const details = rep.details_json || [];
    const fmtD = s => new Date(s).toLocaleDateString('sr-RS');
    const totalRsd = parseFloat(rep.total_rsd) || 0;

    // Header
    const hdr = document.createElement('div'); hdr.style.cssText = 'display:flex;justify-content:space-between;align-items:center;padding:12px 16px;background:var(--surface);border-radius:var(--rs);margin-bottom:12px';
    const hdrL = document.createElement('div');
    const period = document.createElement('div'); period.style.cssText = 'font-weight:600;font-size:14px;color:var(--tx)';
    period.textContent = 'Period: ' + fmtD(rep.period_from) + ' \u2014 ' + fmtD(rep.period_to);
    const info = document.createElement('div'); info.style.cssText = 'font-size:12px;color:var(--tx3);margin-top:2px';
    info.textContent = details.length + ' stavki \u00B7 Ukupno: ' + fNum(totalRsd) + ' RSD \u00B7 Sačuvano: ' + new Date(rep.created_at).toLocaleDateString('sr-RS');
    hdrL.appendChild(period); hdrL.appendChild(info);
    const btnDel = document.createElement('button'); btnDel.className = 'bsm dng';
    btnDel.appendChild(svgIcon('trash', 14)); btnDel.appendChild(document.createTextNode(' Obriši'));
    btnDel.onclick = () => deleteKasnReport(rep.id);
    const hdrR = document.createElement('div'); hdrR.style.cssText = 'display:flex;gap:8px';
    hdrR.appendChild(btnDel);
    hdr.appendChild(hdrL); hdr.appendChild(hdrR);
    content.appendChild(hdr);

    if (!details.length) { hideLoading(); return; }

    // Table
    const card = document.createElement('div'); card.className = 'card'; card.style.cssText = 'padding:0;overflow:hidden';
    const wrap = document.createElement('div'); wrap.style.cssText = 'max-height:600px;overflow-y:auto';
    const tbl = document.createElement('table'); tbl.style.cssText = 'width:100%;font-size:13px;border-collapse:collapse';
    const thead = document.createElement('thead'); const htr = document.createElement('tr');
    ['#', 'Komitent', 'Kategorija', 'Rok plaćanja', 'Dospelo RSD', 'Dani kaš.'].forEach(h => {
      const th = document.createElement('th'); th.textContent = h;
      th.style.cssText = 'text-align:left;padding:8px 10px;border-bottom:2px solid var(--border);color:var(--tx3);font-size:11px;text-transform:uppercase;position:sticky;top:0;background:var(--raised);z-index:1';
      if (h === 'Dospelo RSD' || h === 'Dani kaš.') th.style.textAlign = 'right';
      htr.appendChild(th);
    });
    thead.appendChild(htr); tbl.appendChild(thead);
    const tbody = document.createElement('tbody');
    details.forEach((r, i) => {
      const tr = document.createElement('tr'); tr.style.borderBottom = '1px solid var(--border-lt)';
      const td0 = document.createElement('td'); td0.style.cssText = 'padding:5px 10px;color:var(--tx3);font-size:12px'; td0.textContent = i + 1;
      const td1 = document.createElement('td'); td1.style.cssText = 'padding:5px 10px;font-weight:600;color:var(--tx)'; td1.textContent = r.komitent;
      const td2 = document.createElement('td'); td2.style.cssText = 'padding:5px 10px;color:var(--tx3);font-size:12px'; td2.textContent = r.vrsta_sr || r.vrsta || '';
      const td3 = document.createElement('td'); td3.style.cssText = 'padding:5px 10px;font-size:12px;color:var(--tx2)'; td3.textContent = r.rok || '';
      const td4 = document.createElement('td'); td4.style.cssText = 'padding:5px 10px;text-align:right;font-family:var(--mn);font-weight:600;color:var(--dng)'; td4.textContent = fNum(r.dos);
      const td5 = document.createElement('td'); td5.style.cssText = 'padding:5px 10px;text-align:right;font-family:var(--mn);font-weight:600';
      td5.textContent = r.dk + 'd';
      td5.style.color = r.dk >= 90 ? 'var(--dng)' : r.dk >= 60 ? '#ff8c42' : r.dk >= 30 ? 'var(--warn)' : r.dk > 0 ? 'var(--tx2)' : 'var(--suc)';
      tr.appendChild(td0); tr.appendChild(td1); tr.appendChild(td2); tr.appendChild(td3); tr.appendChild(td4); tr.appendChild(td5);
      tbody.appendChild(tr);
    });
    tbl.appendChild(tbody); wrap.appendChild(tbl); card.appendChild(wrap); content.appendChild(card);
  } catch (e) { content.textContent = 'Greška: ' + (e.message || e); }
  hideLoading();
}

function deleteKasnReport(reportId) {
  showConfirm('Obrisati izveštaj dani kašnjenja? Ova akcija je nepovratna.', async () => {
    try {
      const { error } = await sb.rpc('delete_report', { p_user_id: state.CU.id, p_report_id: reportId });
      if (error) throw error;
      toast('Izveštaj obrisan');
      loadHistKasnjenja();
    } catch (e) { toast('Greška: ' + (e.message || e), 'err'); }
  });
}

// ============================================================
// ISTORIJA AKTIVNOSTI (audit log)
// ============================================================
async function loadHistActivity() {
  const content = document.getElementById('histActivityContent');
  const empty = document.getElementById('histActivityEmpty');
  if (!content) return;
  content.textContent = '';
  showLoading();
  try {
    const { data, error } = await sb.from('audit_log').select('*').order('created_at', { ascending: false }).limit(100);
    if (error) throw error;
    if (!data || !data.length) { if (empty) empty.style.display = 'block'; hideLoading(); return; }
    if (empty) empty.style.display = 'none';

    const card = document.createElement('div'); card.className = 'card'; card.style.cssText = 'padding:0;overflow-x:auto';
    const tbl = document.createElement('table'); tbl.className = 'hist-tbl';
    const thead = document.createElement('thead');
    const htr = document.createElement('tr');
    ['Vreme', 'Akcija', 'Tip', 'Detalji', 'Korisnik'].forEach(h => {
      const th = document.createElement('th'); th.textContent = h; htr.appendChild(th);
    });
    thead.appendChild(htr); tbl.appendChild(thead);
    const tbody = document.createElement('tbody');
    data.forEach(a => {
      const tr = document.createElement('tr');
      const td1 = document.createElement('td'); td1.style.cssText = 'font-size:12px;color:var(--tx2);white-space:nowrap';
      td1.textContent = new Date(a.created_at).toLocaleString('sr-RS', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
      const td2 = document.createElement('td');
      const badge = document.createElement('span');
      badge.style.cssText = 'padding:2px 8px;border-radius:10px;font-size:10px;font-weight:600;background:var(--acc-g);color:var(--acc)';
      badge.textContent = a.action;
      td2.appendChild(badge);
      const td3 = document.createElement('td'); td3.style.cssText = 'font-size:12px;color:var(--tx3)'; td3.textContent = a.entity_type || '';
      const td4 = document.createElement('td'); td4.style.cssText = 'font-size:12px;max-width:300px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap'; td4.textContent = a.entity_name || '';
      const td5 = document.createElement('td'); td5.style.cssText = 'font-size:12px;color:var(--tx2)'; td5.textContent = a.user_id || '';
      tr.appendChild(td1); tr.appendChild(td2); tr.appendChild(td3); tr.appendChild(td4); tr.appendChild(td5);
      tbody.appendChild(tr);
    });
    tbl.appendChild(tbody); card.appendChild(tbl); content.appendChild(card);
  } catch (e) { content.textContent = 'Greška: ' + (e.message || e); }
  hideLoading();
}

// ============================================================
// ISTORIJA MESEČNIH IZVEŠTAJA (cashflow)
// ============================================================
const MO_SR = ['Januar','Februar','Mart','April','Maj','Jun','Jul','Avgust','Septembar','Oktobar','Novembar','Decembar'];

async function loadHistMesecni() {
  const content = document.getElementById('histMesContent');
  const empty = document.getElementById('histMesEmpty');
  if (!content) return;
  content.textContent = '';
  showLoading();
  try {
    const { data, error } = await sb.from('report_history').select('id,period_from,kurs,user_name,created_at,details_json')
      .eq('report_type', 'cashflow').order('period_from', { ascending: false });
    if (error) throw error;
    if (!data?.length) { if (empty) empty.style.display = ''; hideLoading(); return; }
    if (empty) empty.style.display = 'none';

    const card = document.createElement('div'); card.className = 'card'; card.style.cssText = 'padding:0;overflow:hidden';
    const tbl = document.createElement('table'); tbl.className = 'hist-tbl';
    const thead = document.createElement('thead'); const htr = document.createElement('tr');
    ['Period', 'Kurs', 'Sa\u010duvao', 'Datum', ''].forEach(h => { const th = document.createElement('th'); th.textContent = h; htr.appendChild(th); });
    thead.appendChild(htr); tbl.appendChild(thead);
    const tbody = document.createElement('tbody');

    data.forEach(r => {
      const pf = r.period_from ? new Date(r.period_from) : null;
      const monthName = pf ? MO_SR[pf.getMonth()] + ' ' + pf.getFullYear() : '\u2014';
      const savedAt = r.created_at ? new Date(r.created_at).toLocaleDateString('sr-RS') : '\u2014';

      const tr = document.createElement('tr'); tr.style.cssText = 'cursor:pointer;transition:background .15s';
      tr.onmouseenter = () => tr.style.background = 'var(--hover)'; tr.onmouseleave = () => tr.style.background = '';

      const td1 = document.createElement('td'); td1.style.cssText = 'padding:12px 16px;font-weight:700;font-size:16px;color:var(--acc)'; td1.textContent = monthName;
      const td2 = document.createElement('td'); td2.style.cssText = 'padding:12px 16px;font-family:var(--mn);font-size:14px'; td2.textContent = fNum(r.kurs || 0);
      const td3 = document.createElement('td'); td3.style.cssText = 'padding:12px 16px;font-size:14px;color:var(--tx2)'; td3.textContent = r.user_name || '';
      const td4 = document.createElement('td'); td4.style.cssText = 'padding:12px 16px;font-size:14px;color:var(--tx3)'; td4.textContent = savedAt;
      const td5 = document.createElement('td'); td5.style.cssText = 'padding:12px 16px;text-align:right';
      const btnDel = document.createElement('button'); btnDel.className = 'bsm dng'; btnDel.style.cssText = 'font-size:11px;padding:4px 10px';
      btnDel.appendChild(svgIcon('trash', 12)); btnDel.appendChild(document.createTextNode(' Obri\u0161i'));
      btnDel.onclick = ev => { ev.stopPropagation(); showConfirm('Obrisati cashflow za ' + monthName + '?', async () => {
        const { error: dErr } = await sb.rpc('delete_report', { p_user_id: state.CU.id, p_report_id: r.id });
        if (dErr) { toast('Gre\u0161ka: ' + dErr.message, 'err'); return; }
        toast('Obrisano'); loadHistMesecni();
      }); };
      td5.appendChild(btnDel);

      const detailRow = document.createElement('tr'); detailRow.style.display = 'none';
      const detailTd = document.createElement('td'); detailTd.colSpan = 5; detailTd.style.cssText = 'padding:0;background:var(--surface)';
      detailRow.appendChild(detailTd);

      tr.onclick = () => {
        const open = detailRow.style.display !== 'none';
        detailRow.style.display = open ? 'none' : '';
        if (!open && !detailTd.dataset.loaded) {
          detailTd.dataset.loaded = '1';
          renderMesDetail(detailTd, r.details_json, r.kurs);
        }
      };

      tr.appendChild(td1); tr.appendChild(td2); tr.appendChild(td3); tr.appendChild(td4); tr.appendChild(td5);
      tbody.appendChild(tr); tbody.appendChild(detailRow);
    });
    tbl.appendChild(tbody); card.appendChild(tbl); content.appendChild(card);
  } catch (e) { content.textContent = 'Gre\u0161ka: ' + (e.message || e); }
  hideLoading();
}

function renderMesDetail(container, cfData, kurs) {
  if (!cfData) { const d = document.createElement('div'); d.style.cssText = 'padding:20px;color:var(--tx3)'; d.textContent = 'Nema detalja.'; container.appendChild(d); return; }
  const cf = typeof cfData === 'string' ? JSON.parse(cfData) : cfData;
  const k = cf.kurs || kurs || 108;
  const o = cf.opening || {}, inc = cf.income || {}, exp = cf.expenses || {}, tax = cf.taxes || {};

  const wrap = document.createElement('div'); wrap.style.cssText = 'padding:16px 20px';
  const title = document.createElement('div'); title.style.cssText = 'font-weight:700;color:var(--acc);font-size:16px;margin-bottom:12px';
  title.textContent = 'Cashflow (Kurs: ' + fNum(k) + ')';
  wrap.appendChild(title);

  const items = [
    ['BALANCE', o.rsd, o.usd, true], ['Customer Collection RSD', inc.customer_collection_rsd],
    ['Customer Collection USD', null, inc.customer_collection_usd], ['Recapitalization', null, inc.recapitalization],
    ['Tax Refund', inc.tax_refund], ['Payment to Suppliers', -exp.payment_suppliers],
    ['Salaries', -exp.salaries], ['Gov. Taxes', -exp.gov_taxes],
    ['Bank Commission', -exp.bank_commission], ['Monthly VAT', tax.monthly_vat], ['Retained VAT', tax.retained_vat],
  ];

  const tbl = document.createElement('table'); tbl.style.cssText = 'width:100%;border-collapse:collapse;font-size:14px';
  const hdr = document.createElement('tr'); hdr.style.borderBottom = '1px solid var(--border)';
  ['Stavka', 'RSD', 'USD'].forEach(h => { const th = document.createElement('th'); th.textContent = h; th.style.cssText = 'padding:8px 12px;text-align:' + (h === 'Stavka' ? 'left' : 'right') + ';color:var(--tx3);font-size:12px'; hdr.appendChild(th); });
  tbl.appendChild(hdr);

  items.forEach(([label, rsd, usd, bold]) => {
    const tr = document.createElement('tr'); tr.style.borderBottom = '1px solid var(--border-lt)';
    if (bold) tr.style.fontWeight = '700';
    const td1 = document.createElement('td'); td1.style.padding = '8px 12px'; td1.textContent = label;
    const td2 = document.createElement('td'); td2.style.cssText = 'padding:8px 12px;text-align:right;font-family:var(--mn)';
    if (rsd != null && rsd !== 0) { td2.textContent = fNum(rsd); td2.style.color = rsd >= 0 ? 'var(--tx)' : 'var(--dng)'; }
    const td3 = document.createElement('td'); td3.style.cssText = 'padding:8px 12px;text-align:right;font-family:var(--mn)';
    if (usd != null && usd !== 0) { td3.textContent = fNum(usd); td3.style.color = 'var(--acc)'; }
    tr.appendChild(td1); tr.appendChild(td2); tr.appendChild(td3); tbl.appendChild(tr);
  });
  wrap.appendChild(tbl); container.appendChild(wrap);
}
